export default "__VITE_ASSET__BsPZmid6__"